<template>
<svg viewBox="0 0 35 34" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Index`]" width="1em" height="1em" v-bind="$attrs"><path d="M29.0579 26H25.9526V17.7789C25.9526 13.548 22.5099 10.1053 18.2789 10.1053C14.048 10.1053 10.6053 13.548 10.6053 17.7789V22.8886H21.2134V17.5958C21.2134 16.0853 19.9849 14.8568 18.4744 14.8568C16.964 14.8568 15.7355 16.0853 15.7355 17.5958V21.0118H12.6302V17.5958C12.6302 14.3732 15.2519 11.7515 18.4744 11.7515C21.697 11.7515 24.3187 14.3732 24.3187 17.5958V25.9938H7.5V17.7789C7.5 11.8359 12.3359 7 18.2789 7C24.222 7 29.0579 11.8359 29.0579 17.7789V26Z"/></svg>
</template>
<script>

export default {
  name: 'IconIndex',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
